<template>
  <b-row
    class="vh-100 background"
  >
    <b-container
      class="h-100 d-flex justify-content-center align-items-center"
    >
      <div>
        <div class="d-flex justify-content-center align-items-center h-100">
          <div
            class="max-w-375px max-w-md-475px bg-white p-4 shadow-md"
            style="border-radius: 24px;"
          >
            <div class="d-flex flex-column align-items-center">
              <i
                class="fad fa-books-medical text-primary bg-primary-light p-3"
                style="font-size: 32px; border-radius: 50%;"
              />
              <div class="d-flex flex-column align-items-center mt-2">
                <h3 class="text-center">
                  Galen Healthcare Services
                </h3>
                <h6 style="font-size: 14px; font-weight: 500; color: #999;">
                  Schedule your check up today!
                </h6>
              </div>
              <!-- <div class="crm-features">
                <div class="feature-item">
                  <i class="fad fa-users text-primary" />
                  <span>Customer Management</span>
                </div>
                <div class="feature-item">
                  <i class="fad fa-calendar-check text-primary" />
                  <span>Task Management</span>
                </div>
                <div class="feature-item">
                  <i class="fad fa-chart-line text-primary" />
                  <span>Reports and Analytics</span>
                </div>
              </div> -->

              <ValidationObserver
                ref="signinForm"
                v-slot="{ handleSubmit }"
              >
                <form
                  role="form"
                  novalidate
                  @submit.prevent="handleSubmit(onSignIn)"
                >
                  <div
                    class="rounded py-3 px-2"
                  >
                    <b-row>
                      <b-col
                        cols="12"
                      >
                        <b-row>
                          <b-col
                            cols="12"
                          >
                            <ValidationProvider
                              v-slot="{ errors }"
                              vid="organization"
                              name="organization"
                              rules="required"
                            >
                              <b-form-group
                                label="Organization"
                                label-for="fOrganization"
                                label-class="font-weight-bolder"
                                class="mb-2"
                              >
                                <v-select
                                  v-model="selected.organization"
                                  input-id="fOrganization"
                                  label="organization_name"
                                  append-to-body
                                  clearable
                                  placeholder="search organization here"
                                  :options="options.organizations"
                                  :disabled="fetching.organizations || state.busy"
                                  :loading="fetching.organizations"
                                  :calculate-position="calculateDropPosition"
                                  :class="{ 'is-invalid': errors.length > 0 }"
                                  @search="searchOrganizations"
                                >
                                  <template #no-options="">
                                    no available organization
                                  </template>
                                </v-select>
                                <div
                                  v-if="(errors.length > 0)"
                                  class="invalid-feedback"
                                  v-text="errors[0]"
                                />
                              </b-form-group>
                            </ValidationProvider>
                          </b-col>
                          <b-col
                            cols="12"
                          >
                            <ValidationProvider
                              v-slot="{ errors }"
                              vid="username"
                              name="username"
                              rules="required"
                            >
                              <b-form-group
                                label="Username"
                                label-for="username"
                                label-class="font-weight-bold"
                                class="mb-2"
                              >
                                <b-input
                                  id="username"
                                  v-model="credentials.username"
                                  type="text"
                                  placeholder="enter username here"
                                  autocomplete="off"
                                  :state="errors.length > 0 ? false : null"
                                  :disabled="state.busy"
                                />
                                <div
                                  v-if="errors.length > 0"
                                  class="invalid-feedback"
                                  v-text="errors[0]"
                                />
                              </b-form-group>
                            </ValidationProvider>
                          </b-col>

                          <b-col
                            cols="12"
                          >
                            <ValidationProvider
                              v-slot="{ errors }"
                              vid="password"
                              name="password"
                              rules="required"
                            >
                              <b-form-group
                                label="Password"
                                label-for="password"
                                label-class="font-weight-bold"
                                class="mb-2"
                              >
                                <b-input-group
                                  :class="errors.length > 0 ? 'is-invalid' : ''"
                                >
                                  <b-input
                                    id="password"
                                    v-model="credentials.password"
                                    placeholder="enter password here"
                                    autocomplete="off"
                                    :type="passwordType"
                                    :state="errors.length > 0 ? false : null"
                                    :disabled="state.busy"
                                  />
                                  <b-input-group-append>
                                    <b-button
                                      class="pl-2 pr-0 text-dark input-icon"
                                      variant="light"
                                      :disabled="state.busy"
                                      @click.prevent="togglePassword"
                                    >
                                      <i
                                        v-if="state.visible_password"
                                        class="fad fa-eye h5 mb-0 min-w-40px"
                                      />
                                      <i
                                        v-else
                                        class="fad fa-eye-slash h5 mb-0 min-w-40px"
                                      />
                                    </b-button>
                                  </b-input-group-append>
                                </b-input-group>
                                <div
                                  v-if="errors.length > 0"
                                  class="invalid-feedback"
                                  v-text="errors[0]"
                                />
                              </b-form-group>
                            </ValidationProvider>
                          </b-col>

                        </b-row>
                      </b-col>
                    </b-row>
                    <b-row class="px-2 pt-3">

                      <b-overlay
                        class="col-12 px-1"
                        rounded
                        opacity="0.1"
                        spinner-variant="warning"
                        spinner-small
                        :show="state.local"
                      >
                        <b-button
                          size="md"
                          type="submit"
                          class="w-100"
                          variant="primary"
                          :disabled="state.busy"
                        >
                          Sign In
                        </b-button>
                      </b-overlay>

                      <b-col class="text-divider">
                        <span>&nbsp; or</span>
                      </b-col>

                      <b-overlay
                        class="col-12 px-1"
                        rounded
                        opacity="0.1"
                        spinner-variant="success"
                        spinner-small
                      >
                        <b-button
                          size="sm"
                          type="button"
                          class="w-100"
                          variant="secondary"
                          :disabled="state.busy"
                          @click="registerCard"
                        >
                          Register Card
                        </b-button>
                      </b-overlay>
                    </b-row>
                  </div>
                </form>
              </ValidationObserver>
            </div>

          </div>
        </div>
      </div>
    </b-container>
  </b-row>
</template>

<script>
import MISC from '@/mixins/misc'
import URL from '@/mixins/image-url'
import { core } from '@/config/pluginInit'
import { SSharedAuth, SSharedSSO } from '@/services'
import { Oauth2 } from 'universal-social-auth'
import MOrganizations from '@/mixins/accounts/organizations'

export default {
  name: 'SharedLogin',

  middleware: ['guest'],

  metaInfo: () => ({
    title: 'Sign In'
  }),

  mixins: [
    MOrganizations,
    URL,
    MISC
  ],

  data: () => ({
    state: {
      busy: false,
      local: false,
      sso: false,
      visible_password: false
    },
    credentials: {
      organization_code: null,
      username: null,
      password: 'P@ssw0rd'
    },
    singleSignOn: Oauth2
  }),

  computed: {

    companyLogo () {
      return this.transformToImageUrl(this.getCompany())
    },

    passwordType () {
      return this.state.visible_password ? 'text' : 'password'
    }

  },

  watch: {
    'selected.organization' (organization) {
      this.credentials.organization_code = organization?.organization_code || null
    }
  },

  mounted () {
    core.index()

    this.getOrganizations(this)
  },

  methods: {

    togglePassword () {
      this.state.visible_password = !this.state.visible_password
    },

    registerCard () {
      this.$router.push({
        name: 'shared.client-registrations'
      })
    },

    async saveAndGetCurrentUser (token) {
      this.$store.dispatch('auth/saveToken', token)
      return new Promise((resolve, reject) => {
        SSharedAuth.getCurrentUser().then(
          ({ data: user }) => {
            this.$store.dispatch('auth/fetchUserSuccess', {
              id: user.id,
              role_id: user.role.id,
              role_code: user.role.role_code,
              role_name: user.role.role_name,
              organization_id: user.organization.id,
              organization_code: user.organization.organization_code,
              organization_name: user.organization.organization_name,
              organization_type: user.organization.organization_type,
              name: user.name,
              username: user.username,
              email: user.email
            })

            const currentUser = this.$store.getters['auth/user']
            this.$router.replace({
              name: currentUser ? `${currentUser.organization_type}.dashboard` : 'dashboard'
            }, () => {
              resolve(user)
            })
          }
        ).catch(error => {
          this.$store.dispatch('auth/fetchUserFailure')
          reject(error)
        })
      })
    },

    async onSignIn () {
      await this.$refs.signinForm.validate().then(
        validSignIn => {
          if (validSignIn) {
            this.state.busy = this.state.local = true
            SSharedAuth.signIn(this.credentials).then(
              ({ data: { token } }) => {
                this.saveAndGetCurrentUser(token).finally(() => {
                  this.state.busy = this.state.local = false
                })
              }
            ).catch(() => {
              this.state.busy = this.state.local = false
            })
          }
        }
      )
    },

    async onSignInWithAljaySSO (event) {
      event.preventDefault()
      this.state.busy = this.state.sso = true
      this.$usAuth.authenticate('oauth2', this.singleSignOn).then(
        authorized => {
          SSharedSSO.post(authorized).then(
            ({ data: { token } }) => {
              this.saveAndGetCurrentUser(token).finally(() => {
                this.state.busy = this.state.local = false
              })
            }
          ).catch(() => {
            this.state.busy = this.state.sso = false
          })
        }
      )
    }
  }
}
</script>

<style scoped lang="scss">

  .background {
    background: var(--iq-body-bg);
    background-image:
        linear-gradient(135deg, rgba(255, 255, 255, 0.616), rgba(248, 250, 248, 0.657)),
        url('../../assets/images/bg-01.jpg');
        // url('https://images.unsplash.com/photo-1538108149393-fbbd81895907?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80');
    background-size: cover;
    background-position: center;
    background-attachment: fixed;
    background-repeat: no-repeat;
    min-height: 100vh;
    width: 100vw;
    padding: 0px;
    margin: 0px;
  }

  .text-divider {
    margin: 2em 0;
    line-height: 0;
    text-align: center;
    color: gray;
    padding: 0px 5px;
  }
  .text-divider span {
    background-color: rgb(255, 255, 255);
    padding: 0 0.5em;
  }
  .text-divider:before {
    content: " ";
    display: flex;
    align-items: center;
    justify-content: center;
    border-top: 1px solid gray;
    border-bottom: 1px solid #f7f7f7;
  }
  .text-divider span:before  {
    content: "";
    display: block;
    margin-top: -3px;
  }
  .text-divider span:after  {
    display: block;
    margin-top: -3px;
  }
  </style>
